import get from 'lodash/get';

export const selectTourFinished = (state) => get(state, 'preferences.tourFinished', false);

export const selectNewTourFinished = (state, tourSection) => get(state, `preferences.${tourSection}`, false);
